import '../../styles/Help/Help.css';
import styles from './payment-method.module.css';
import classNames from 'classnames/bind';

import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

// Components
import { Button, TopMenu, GoBackArrow } from '../../components';

// Services
import { GlobalService } from '../../hexagonal-architecture-frontend-base/src/domain/services/Global.service';
import { useTranslation } from 'react-i18next';

// Interfaces

// Images
import Callcenter from '../../img/HelpImg/helpLuracare.png';

// Hooks
import { useViewport } from '../../hooks/use-viewport';
import {
  useSelectedPatient,
  useSelectedQuoteValue,
  useSessionValue,
  useSetSelectedQuote,
  useUpdateQuote,
} from '../../hooks';

const cx = classNames.bind(styles);

const PaymentMethod = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { patientId, reportId } = useParams();
  const textBase = 'pages.paymentMethod';
  const total = localStorage.getItem('tot');
  const { userInfo } = useSessionValue();
  const { setSelectedPatient } = useSelectedPatient();
  const { setSelectedQuote, removeSelectedQuote } = useSetSelectedQuote();
  const { selectedQuote } = useSelectedQuoteValue();
  const { updateQuote } = useUpdateQuote();

  const tutorName = userInfo?.tutorFullName;

  /**********
   * States *
   **********/
  const { isScreenBig } = useViewport();

  /*********
   * Hooks *
   *********/
  useEffect(() => {
    if(!selectedQuote?.Access_To_Payment_Method && selectedQuote !== null) {
      updateQuote.accessToPaymentMethod(selectedQuote?.id as string, true);
    }
  }, [selectedQuote]);

  useEffect(() => {
    setSelectedPatient(patientId as string);
  }, [patientId]);

  useEffect(() => {
    if (reportId == null) {
      removeSelectedQuote();
      return;
    }
    setSelectedQuote(reportId);
  }, [reportId]);

  const handleNavigatePaymentMethod = (key: string) => {
    navigate(`/informeDetallado/${patientId}/${reportId}/paymentmethod/${key}payment`);
  };

  const handleOnClickSelectPaymentMethod = (key: string) => {
    if (selectedQuote?.Grand_Total) {
      switch (key) {
        case 'card':
          handleNavigatePaymentMethod(key);
          break;
        case 'transfer':
          handleNavigatePaymentMethod(key);
          break;
        case 'split':
          handleNavigatePaymentMethod(key);
          break;
      }
    }
  };

  /**************
   * JSX Values *
   **************/
  document.title = `LuraCare - ${GlobalService.uppercaseFirstLetter(
    t(`${textBase}.selectPaymentMethod`),
  )}`;

  // Buttons definitions
  const buttonsDefinition: string[] = ['card', 'transfer', 'split'];
  const isFinancAvailable = (button: string) => {
    return total && button === 'split' ? parseInt(total.replace('.', '')) >= 300 : true;
  };

  // Los botones
  const helpButtons = buttonsDefinition
    .filter(button => button !== 'split' || isFinancAvailable(button))
    .map((button, index) => (
      <Button
        key={index}
        onClick={() => handleOnClickSelectPaymentMethod(buttonsDefinition[index])}
        fullWidth={true}
      >
        {GlobalService.uppercaseFirstLetter(
          t(`${textBase}.${button === 'split' ? button + 'Short' : button}`),
        )}
      </Button>
    ));

  return (
    <div className={cx('main-container')}>
      <TopMenu
        title={GlobalService.uppercaseFirstLetter(t(`${textBase}.title`))}
        userName={isScreenBig ? tutorName : undefined}
        leftIcon={!isScreenBig}
      />

      <div className={cx('title--container')}>
        {isScreenBig ? (
          <GoBackArrow to={`/informeDetallado/${patientId}/${reportId}/confirmation`} />
        ) : null}

        <h3
          className={cx('title--text')}
          style={{
            display: 'block',
            overflowWrap: 'break-word',
            maxWidth: '100%',
            lineClamp: 2,
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
          }}
        >
          {GlobalService.uppercaseFirstLetter(t(`${textBase}.selectPaymentMethod`))}
        </h3>
      </div>

      <div className={cx('body-container')}>
        <div className={cx('buttons-container')}>{helpButtons}</div>

        <div className='w-[497px] hidden lg:flex'>
          <img src={Callcenter} width='100%' alt='help image' />
        </div>
      </div>
    </div>
  );
};

export default PaymentMethod;
